<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'

defineProps<{
  videoUrl: string
  title: string
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

// Handle escape key to close modal
const handleKeyDown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    emit('close')
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleKeyDown)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown)
})
</script>

<template>
  <div 
    class="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
    @click.self="$emit('close')"
  >
    <!-- Close Button -->
    <button
      @click="$emit('close')"
      class="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
    >
      ✕
    </button>

    <!-- Video Title -->
    <h3 class="absolute top-4 left-4 text-xl font-semibold text-white">
      {{ title }}
    </h3>

    <!-- Video Player -->
    <div class="w-full max-w-4xl">
      <div class="relative aspect-video">
        <video
          class="w-full h-full rounded-lg"
          :src="videoUrl"
          controls
          autoplay
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </div>
</template>